import type { StateCode, StateRegion } from './types.js';

export const US_REGIONS: Record<StateCode, StateRegion> = {
  AL: { slug: 'alabama', name: 'Alabama' },
  AK: { slug: 'alaska', name: 'Alaska' },
  AZ: { slug: 'arizona', name: 'Arizona' },
  AR: { slug: 'arkansas', name: 'Arkansas' },
  CA: { slug: 'california', name: 'California' },
  CO: { slug: 'colorado', name: 'Colorado' },
  CT: { slug: 'connecticut', name: 'Connecticut' },
  DE: { slug: 'delaware', name: 'Delaware' },
  FL: { slug: 'florida', name: 'Florida' },
  GA: { slug: 'georgia', name: 'Georgia' },
  HI: { slug: 'hawaii', name: 'Hawaii' },
  ID: { slug: 'idaho', name: 'Idaho' },
  IL: { slug: 'illinois', name: 'Illinois' },
  IN: { slug: 'indiana', name: 'Indiana' },
  IA: { slug: 'iowa', name: 'Iowa' },
  KS: { slug: 'kansas', name: 'Kansas' },
  KY: { slug: 'kentucky', name: 'Kentucky' },
  LA: { slug: 'louisiana', name: 'Louisiana' },
  ME: { slug: 'maine', name: 'Maine' },
  MD: { slug: 'maryland', name: 'Maryland' },
  MA: { slug: 'massachusetts', name: 'Massachusetts' },
  MI: { slug: 'michigan', name: 'Michigan' },
  MN: { slug: 'minnesota', name: 'Minnesota' },
  MS: { slug: 'mississippi', name: 'Mississippi' },
  MO: { slug: 'missouri', name: 'Missouri' },
  MT: { slug: 'montana', name: 'Montana' },
  NE: { slug: 'nebraska', name: 'Nebraska' },
  NV: { slug: 'nevada', name: 'Nevada' },
  NH: { slug: 'new-hampshire', name: 'New Hampshire' },
  NJ: { slug: 'new-jersey', name: 'New Jersey' },
  NM: { slug: 'new-mexico', name: 'New Mexico' },
  NY: { slug: 'new-york', name: 'New York' },
  NC: { slug: 'north-carolina', name: 'North Carolina' },
  ND: { slug: 'north-dakota', name: 'North Dakota' },
  OH: { slug: 'ohio', name: 'Ohio' },
  OK: { slug: 'oklahoma', name: 'Oklahoma' },
  OR: { slug: 'oregon', name: 'Oregon' },
  PA: { slug: 'pennsylvania', name: 'Pennsylvania' },
  RI: { slug: 'rhode-island', name: 'Rhode Island' },
  SC: { slug: 'south-carolina', name: 'South Carolina' },
  SD: { slug: 'south-dakota', name: 'South Dakota' },
  TN: { slug: 'tennessee', name: 'Tennessee' },
  TX: { slug: 'texas', name: 'Texas' },
  UT: { slug: 'utah', name: 'Utah' },
  VT: { slug: 'vermont', name: 'Vermont' },
  VA: { slug: 'virginia', name: 'Virginia' },
  WA: { slug: 'washington', name: 'Washington' },
  WV: { slug: 'west-virginia', name: 'West Virginia' },
  WI: { slug: 'wisconsin', name: 'Wisconsin' },
  WY: { slug: 'wyoming', name: 'Wyoming' },
  DC: { slug: 'district-of-columbia', name: 'District of Columbia' },
  US: { slug: 'united-states', name: 'United States' },
};
